export default "skymp5-front/a7dbff6bac12c749117418c85ecfcba1.png";